export const HORIZONTAL_ITEM_HEADER_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.HorizontalItemHeaderWidgetElement';
